import AddIcon from "@mui/icons-material/Add";
import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import GlobalButton from "../../../components/button";
import DynamicTable from "../../../components/dynamicTable";
import {
  getAllBroadbandByType,
  updateBroadBand,
} from "../../../services/BroadbandApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import AddEditBroadBand from "./AddEditBroadbandDialog";
import AppLoader from "../../../components/loader";

const tableHeader = [
  "Created At",
  "Name",
  "Buy Price",
  "Sale Price",
  "High Price",
  "Price ( Length 12 )",
  "Price ( Length 18 )",
  "Price ( Length 24 )",
  "Price ( Length 36 )",
  "Status",
  "Actions",
];

const displayRows = [
  "lead_created_date",
  "value",
  "buyPrice",
  "salePrice",
  "highPrice",
  "length12",
  "length18",
  "length24",
  "length36",
  "broadband_status",
  "actions",
];

const LegacyBroadband = () => {
  const openAddEditDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allLegacy, setAllLegacy] = useState([]);

  useEffect(() => {
    fetchAllLegacyBroadBands();
  }, []);

  const fetchAllLegacyBroadBands = async () => {
    try {
      setIsLoading(true);
      const response = await getAllBroadbandByType("legacy");
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllLegacy(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlChangeBroadbandStatus = async (row, e) => {
    try {
      setIsLoading(true);
      const response = await updateBroadBand(row?._id, { status: e });
      if (response.data.status === "success") {
        handleOpenSnackBar("success", "Status updated successfully");
        fetchAllLegacyBroadBands();
      } else {
        handleOpenSnackBar("success", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("success", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />
      <Stack
        direction={"row"}
        alignItems={"flex-end"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={2}
        mb={2}
      >
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "1.75rem" }}
        >
          List Of Legacy Tariffs
        </Typography>
        <GlobalButton
          variant="custom_gradient"
          title="Add Legacy Tariffs"
          startIcon={<AddIcon />}
          style={{
            width: { xs: "100%", sm: "auto" },
            borderRadius: "100px",
          }}
          handleClickBtn={() =>
            openAddEditDialog.current.openDialog({
              type: "add",
              data: null,
              getData: fetchAllLegacyBroadBands,
              value: "legacy",
            })
          }
        />
      </Stack>

      <DynamicTable
        tableData={allLegacy}
        displayRows={displayRows}
        tableHeader={tableHeader}
        handlChangeBroadbandStatus={handlChangeBroadbandStatus}
        showEdit={true}
        handleEdit={(row) => {
          openAddEditDialog.current.openDialog({
            type: "edit",
            data: row,
            getData: fetchAllLegacyBroadBands,
            value: "legacy",
          });
        }}
      />
      {allLegacy?.length === 0 && isLoading === false && (
        <Typography variant="h5" fontWeight={600} textAlign={"center"}>
          No Data Found !
        </Typography>
      )}

      <AddEditBroadBand ref={openAddEditDialog} />
    </Box>
  );
};

export default LegacyBroadband;
